import { useQuery } from '@tanstack/react-query'

import { caaMetricsInstance } from '../..'

export function getOperationalCAAMetricsTherapistMonthQueryKey({
  personaName,
  month,
  year
}: {
  personaName?: string
  month: number
  year: number
}) {
  return ['operationalCAAMetricsTherapistMonth', { personaName, month, year }]
}

export function useOperationalCAAMetricsTherapistMonthQuery({
  personaName,
  month,
  year,
  enabled
}: {
  personaName?: string
  month: number
  year: number
  enabled?: boolean
}) {
  return useQuery({
    queryKey: getOperationalCAAMetricsTherapistMonthQueryKey({
      personaName,
      month,
      year
    }),
    queryFn: async () =>
      await caaMetricsInstance.getOperationalCAAMetricsTherapistMonth({
        personaName,
        month,
        year
      }),
    enabled
  })
}
